import { render, staticRenderFns } from "./forecast_Num.vue?vue&type=template&id=0ec1685b&scoped=true&"
import script from "./forecast_Num.vue?vue&type=script&lang=js&"
export * from "./forecast_Num.vue?vue&type=script&lang=js&"
import style0 from "./forecast_Num.vue?vue&type=style&index=0&id=0ec1685b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec1685b",
  null
  
)

component.options.__file = "forecast_Num.vue"
export default component.exports